import React from "react";
import { Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import SVG_Svg, { G as SVG_G, Path as SVG_Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent(SVG_Path);
const G = Animated.createAnimatedComponent(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none"> <desc id="IMP.BLUE">{"#InviteIcon":{"type":"SELECTOR","constraint":"xMinYMin meet","width":17.999614715576172,"height":17},"#InvitIcon":{"type":"SELECTOR","constraint":"none","width":17.999614715576172,"height":17}}</desc>
 * <g id="InviteIcon">
 * <path id="InvitIcon" d="M12.5806 10.8426L12.5807 10.8426C12.9742 11.0296 13.4449 10.8623 13.632 10.4687C13.8191 10.0751 13.6517 9.60437 13.2581 9.41729C12.9969 9.2931 12.7314 9.18245 12.462 9.08546C13.4867 8.23379 14.1406 6.94974 14.1406 5.51562C14.1406 2.95669 12.059 0.875 9.49999 0.875C6.94102 0.875 4.85936 2.95669 4.85936 5.51562C4.85936 6.9512 5.51463 8.23643 6.5411 9.08809C5.59997 9.42552 4.71662 9.92317 3.93642 10.5649C2.3961 11.8319 1.32509 13.599 0.920709 15.5415C0.788148 16.1781 0.947048 16.8325 1.3566 17.3361C1.7642 17.8374 2.36903 18.125 3.01518 18.125H11.1933C11.6291 18.125 11.9824 17.7717 11.9824 17.3359C11.9824 16.9001 11.6291 16.5469 11.1933 16.5469H3.01518C2.78364 16.5469 2.64473 16.4189 2.58095 16.3405C2.47241 16.207 2.43024 16.0334 2.46569 15.8631L2.34332 15.8376L2.4657 15.8631C3.14266 12.6114 6.01074 10.2348 9.32309 10.1529C9.38181 10.1551 9.44076 10.1562 9.49999 10.1562C9.55982 10.1562 9.6194 10.1551 9.67867 10.1529C10.6931 10.1772 11.6683 10.4089 12.5806 10.8426ZM12.6343 10.7297C12.9656 10.8871 13.3617 10.7463 13.5191 10.415L12.6343 10.7297ZM12.5625 5.51562C12.5625 7.15053 11.2744 8.4906 9.65987 8.57398C9.60669 8.57306 9.5534 8.57258 9.49999 8.57258C9.44702 8.57258 9.3941 8.57309 9.34129 8.57405C7.7262 8.49126 6.43749 7.15094 6.43749 5.51562C6.43749 3.82705 7.81142 2.45312 9.49999 2.45312C11.1886 2.45312 12.5625 3.82705 12.5625 5.51562ZM18.3356 14.0566H16.6344V12.3555C16.6344 11.9197 16.2811 11.5664 15.8453 11.5664C15.4095 11.5664 15.0563 11.9197 15.0563 12.3555V14.0566H13.3551C12.9193 14.0566 12.566 14.4099 12.566 14.8457C12.566 15.2815 12.9193 15.6348 13.3551 15.6348H15.0563V17.3359C15.0563 17.7717 15.4095 18.125 15.8453 18.125C16.2811 18.125 16.6344 17.7717 16.6344 17.3359V15.6348H18.3356C18.7713 15.6348 19.1246 15.2815 19.1246 14.8457C19.1246 14.4099 18.7713 14.0566 18.3356 14.0566Z" fill="white" stroke="white" stroke-width="0.25"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#InviteIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMin meet",
 * 		"width": 17.999614715576172,
 * 		"height": 17
 * 	},
 * 	"#InvitIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 17.999614715576172,
 * 		"height": 17
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const InviteIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 20,
      height: 19,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;

  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg
          fill="none"
          id="svg_root"
          ref={svgRef}
          {...props}
          style={svgStyle}
          preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 20 19"
        >
          <G id="InviteIcon">
            <Svg preserveAspectRatio="none" viewBox="0 0 20 19">
              <Path
                id="InvitIcon"
                d="M12.5806 10.8426L12.5807 10.8426C12.9742 11.0296 13.4449 10.8623 13.632 10.4687C13.8191 10.0751 13.6517 9.60437 13.2581 9.41729C12.9969 9.2931 12.7314 9.18245 12.462 9.08546C13.4867 8.23379 14.1406 6.94974 14.1406 5.51562C14.1406 2.95669 12.059 0.875 9.49999 0.875C6.94102 0.875 4.85936 2.95669 4.85936 5.51562C4.85936 6.9512 5.51463 8.23643 6.5411 9.08809C5.59997 9.42552 4.71662 9.92317 3.93642 10.5649C2.3961 11.8319 1.32509 13.599 0.920709 15.5415C0.788148 16.1781 0.947048 16.8325 1.3566 17.3361C1.7642 17.8374 2.36903 18.125 3.01518 18.125H11.1933C11.6291 18.125 11.9824 17.7717 11.9824 17.3359C11.9824 16.9001 11.6291 16.5469 11.1933 16.5469H3.01518C2.78364 16.5469 2.64473 16.4189 2.58095 16.3405C2.47241 16.207 2.43024 16.0334 2.46569 15.8631L2.34332 15.8376L2.4657 15.8631C3.14266 12.6114 6.01074 10.2348 9.32309 10.1529C9.38181 10.1551 9.44076 10.1562 9.49999 10.1562C9.55982 10.1562 9.6194 10.1551 9.67867 10.1529C10.6931 10.1772 11.6683 10.4089 12.5806 10.8426ZM12.6343 10.7297C12.9656 10.8871 13.3617 10.7463 13.5191 10.415L12.6343 10.7297ZM12.5625 5.51562C12.5625 7.15053 11.2744 8.4906 9.65987 8.57398C9.60669 8.57306 9.5534 8.57258 9.49999 8.57258C9.44702 8.57258 9.3941 8.57309 9.34129 8.57405C7.7262 8.49126 6.43749 7.15094 6.43749 5.51562C6.43749 3.82705 7.81142 2.45312 9.49999 2.45312C11.1886 2.45312 12.5625 3.82705 12.5625 5.51562ZM18.3356 14.0566H16.6344V12.3555C16.6344 11.9197 16.2811 11.5664 15.8453 11.5664C15.4095 11.5664 15.0563 11.9197 15.0563 12.3555V14.0566H13.3551C12.9193 14.0566 12.566 14.4099 12.566 14.8457C12.566 15.2815 12.9193 15.6348 13.3551 15.6348H15.0563V17.3359C15.0563 17.7717 15.4095 18.125 15.8453 18.125C16.2811 18.125 16.6344 17.7717 16.6344 17.3359V15.6348H18.3356C18.7713 15.6348 19.1246 15.2815 19.1246 14.8457C19.1246 14.4099 18.7713 14.0566 18.3356 14.0566Z"
                fill="white"
                stroke="white"
                strokeWidth="0.25"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 20 19"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="InvitIcon"
          d="M12.5806 10.8426L12.5807 10.8426C12.9742 11.0296 13.4449 10.8623 13.632 10.4687C13.8191 10.0751 13.6517 9.60437 13.2581 9.41729C12.9969 9.2931 12.7314 9.18245 12.462 9.08546C13.4867 8.23379 14.1406 6.94974 14.1406 5.51562C14.1406 2.95669 12.059 0.875 9.49999 0.875C6.94102 0.875 4.85936 2.95669 4.85936 5.51562C4.85936 6.9512 5.51463 8.23643 6.5411 9.08809C5.59997 9.42552 4.71662 9.92317 3.93642 10.5649C2.3961 11.8319 1.32509 13.599 0.920709 15.5415C0.788148 16.1781 0.947048 16.8325 1.3566 17.3361C1.7642 17.8374 2.36903 18.125 3.01518 18.125H11.1933C11.6291 18.125 11.9824 17.7717 11.9824 17.3359C11.9824 16.9001 11.6291 16.5469 11.1933 16.5469H3.01518C2.78364 16.5469 2.64473 16.4189 2.58095 16.3405C2.47241 16.207 2.43024 16.0334 2.46569 15.8631L2.34332 15.8376L2.4657 15.8631C3.14266 12.6114 6.01074 10.2348 9.32309 10.1529C9.38181 10.1551 9.44076 10.1562 9.49999 10.1562C9.55982 10.1562 9.6194 10.1551 9.67867 10.1529C10.6931 10.1772 11.6683 10.4089 12.5806 10.8426ZM12.6343 10.7297C12.9656 10.8871 13.3617 10.7463 13.5191 10.415L12.6343 10.7297ZM12.5625 5.51562C12.5625 7.15053 11.2744 8.4906 9.65987 8.57398C9.60669 8.57306 9.5534 8.57258 9.49999 8.57258C9.44702 8.57258 9.3941 8.57309 9.34129 8.57405C7.7262 8.49126 6.43749 7.15094 6.43749 5.51562C6.43749 3.82705 7.81142 2.45312 9.49999 2.45312C11.1886 2.45312 12.5625 3.82705 12.5625 5.51562ZM18.3356 14.0566H16.6344V12.3555C16.6344 11.9197 16.2811 11.5664 15.8453 11.5664C15.4095 11.5664 15.0563 11.9197 15.0563 12.3555V14.0566H13.3551C12.9193 14.0566 12.566 14.4099 12.566 14.8457C12.566 15.2815 12.9193 15.6348 13.3551 15.6348H15.0563V17.3359C15.0563 17.7717 15.4095 18.125 15.8453 18.125C16.2811 18.125 16.6344 17.7717 16.6344 17.3359V15.6348H18.3356C18.7713 15.6348 19.1246 15.2815 19.1246 14.8457C19.1246 14.4099 18.7713 14.0566 18.3356 14.0566Z"
          fill="white"
          stroke="white"
          strokeWidth="0.25"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(InviteIcon);
